<template>
  <div class="container">
    <!-- ポータルの方でログインが済んでいない場合、ログインしてもらう -->
    <div class="logo">
      <gl-logo-bizoope size="middle"/>
    </div>

    <div v-if="unauthed" class="login-form">
      <!-- <md-field>
        <label>Company</label>
        <md-select v-model="loginForm.companyCode">
          <md-option v-for="c in companies" :key="c.code" :value="c.code">{{
            c.name
          }}</md-option>
        </md-select>
      </md-field> -->
      <md-field>
        <label>Login ID</label>
        <md-input v-model="loginForm.loginId" @keyup.enter="login(loginForm.companyCode, loginForm.loginId, loginForm.password)"></md-input>
      </md-field>
      <md-field>
        <label>Password</label>
        <md-input type="password" v-model="loginForm.password" @keyup.enter="login(loginForm.companyCode, loginForm.loginId, loginForm.password)"></md-input>
      </md-field>
      <p class="actions">
        <md-button class="md-primary" :disabled="loading" v-on:click="login(loginForm.companyCode, loginForm.loginId, loginForm.password)">Login</md-button>
      </p>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
    </div>
    <!-- ポータルの方でログインが済んでいない場合、ログインしてもらう -->
    <div v-if="loggedInButRequiresPasswordChange">
      <p>
        パスワードが初期状態のままです
      </p>
      <p>
        <a href="#" @click="toPasswordChange">パスワードを変更</a>してから再度お試しください
      </p>
    </div>
    <!-- ポータルの方でログインが既に済んでいる場合 -->
    <div v-if="loggedIn" class="account-select-form">
      <p class="main">
        <span class="login-id">{{ authInfo.loginId + "@" + companyName }}</span>でログインしています
      </p>
      <p>
        <md-field>
          <label>Password</label>
          <md-input type="password" v-model="loginForm.password" @keyup.enter="login(authInfo.companyCode,authInfo.loginId, loginForm.password)"></md-input>
        </md-field>
      </p>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      <p>
        <md-button class="md-primary md-raised" @click="login(authInfo.companyCode,authInfo.loginId, loginForm.password)">このアカウントで続行する</md-button>
      </p>
      <p>
        または
        <a href="#" @click="logout">ログアウト</a>
        して他のアカウントを使用する
      </p>
    </div>
  </div>
</template>

<script>
import {
  requestToken,
  getUserId,
  getCompanyCode,
  getLoginId,
  getAccessToken,
  getRefreshToken,
} from '@/util/token'

function isInvalidCredential(response) {
  if (response.status !== 400) {
    return false
  }
  if (!response.data) {
    return true
  }
  if (!response.data.cause) {
    return true
  }

  return response.data.cause.toUpperCase() === 'INVALIDCREDENTIALS'
}

const originAllowed = new Set(
  (process.env.VUE_APP_SSO_ORIGIN_ALLOWED || '').split(','),
)

/**
 * SSOで認証するために、別アプリケーションから委譲されたときに
 * 仕様するページです。
 *
 * SSOしたいアプリケーションはこのページを開き、messageイベントを処理
 * することで、このページで取得した認証情報をもらうことができます。
 *
 * 例）
 *
 * ```javascript
 * window.addEventListener('message', e => {
 *   // このWindowに対するMessageは全て受信してしまうので、SSOを委譲したOrigin
 *   // からのMessageであるか確実にチェックする
 *   if (e.origin !== new URL(AUTH_URL).origin) {
 *     return
 *   }
 *
 *   if (
 *      !e.data.loginId ||
 *      !e.data.accessToken ||
 *      !e.data.refreshToken
 *   ) {
 *     throw new Error('認証ページから送信された認証情報が不正です')
 *   }
 *
 *   // 受信した認証情報で処理を続行
 * }, false)
 * ```
 */

const LAST_COMPANY_CODE_KEY = 'bizoo.last.companyCode'
const storage = localStorage

export default {
  name: 'LoginSSO',
  data() {
    return {
      /**
       * このページを開いた時点で保存されている認証情報
       */
      authInfo: {
        userId: undefined,
        companyCode: 'dummy',
        loginId: undefined,
      },
      /**
       * ログインフォームの入力値
       */
      loginForm: {
        companyCode: 'dummy',
        loginId: '',
        password: '',
      },
      /**
       * ログイン処理でのエラーメッセージ
       */
      errorMessage: undefined,
      /**
       * 認証処理を行っている最中か否か
       */
      loading: false,
      /**
       * 選択企業
       */
      companies: [],
    }
  },
  computed: {
    /**
     * 未認証状態
     */
    unauthed() {
      return !this.$store.state.user.userId
    },
    /**
     * 認証は通ったが、パスワード変更が必要
     */
    loggedInButRequiresPasswordChange() {
      return (
        this.$store.state.user.userId &&
        this.$store.state.user.requiresPasswordChange
      )
    },
    /**
     * 認証済
     */
    loggedIn() {
      return (
        this.$store.state.user.userId &&
        !this.$store.state.user.requiresPasswordChange
      )
    },
    companyName() {
      // if (this.companies) {
      //   const company = this.companies.find(c => c.code === this.companyCode)
      //   if (company) {
      //     return company.name
      //   }
      // }
      return ''
    },
  },
  methods: {
    /**
     * ログイン処理
     */
    async login(companyCode, loginId, password) {
      this.loading = true
      this.errorMessage = undefined

      if (!loginId || !password /*|| !companyCode*/) {
        this.loading = false
        return
      }

      try {
        await this.$store.dispatch('login', { companyCode, loginId, password })
      } catch (error) {
        if (isInvalidCredential(error.response)) {
          this.errorMessage = error.response.data.message
          this.loginForm.password = ''
          this.loading = false
          return
        }
      }
      storage.setItem(LAST_COMPANY_CODE_KEY, companyCode)
      this.loading = false

      if (this.$store.state.user.requiresPasswordChange) {
        // パスワードの変更が済んでいないユーザーはSSOは使えない。
        return
      }

      if (!window.opener) {
        throw new Error('SSO対象ウィンドウが見つかりません')
      }

      // ログインに成功（とアクセストークンの保存の完了）が確認できているので、
      // 呼び出し元に渡す用のトークンを別途取得する（リフレッシュトークンを
      // ポータルでもSSO利用側でも利用することになってしまうので）。
      const authResponse = await requestToken({
        companyCode,
        loginId,
        password,
      })

      this.sendTokens({
        userId: authResponse.userId,
        companyCode: authResponse.companyCode,
        loginId: authResponse.loginId,
        accessToken: authResponse.accessToken,
        refreshToken: authResponse.refreshToken,
        refreshUrl: authResponse.refreshUrl,
      })

      window.close()
    },
    /**
     * 現状保存されているログインIDで認証を続行する
     */
    continueByCurrentLoginId() {
      this.login(
        this.authInfo.companyCode,
        this.authInfo.loginId,
        this.loginForm.password,
      )
    },
    /**
     * トークン（とその付随情報）をSSO利用Windowに送信する
     *
     * 指定されているオリジンが許可オリジン（ホワイトリスト）に含まれていない場合
     * 送信は行われず、エラーを送出します。
     */
    sendTokens({
      userId,
      companyCode,
      loginId,
      accessToken,
      refreshToken,
      refreshUrl,
    }) {
      const targetOrigin = this.$route.query.q
      console.log('targetOrigin', targetOrigin)
      console.log('originAllowed', originAllowed)
      if (
        !(targetOrigin === window.origin || originAllowed.has(targetOrigin))
      ) {
        if (targetOrigin.startsWith('http://localhost')) {
          // localhostはPass
        } else {
          throw new Error(`対象外オリジン ${targetOrigin}`)
        }
      }

      window.opener.postMessage(
        {
          userId,
          companyCode,
          loginId,
          accessToken,
          refreshToken,
          refreshUrl,
        },
        targetOrigin,
      )
    },
    toPasswordChange() {
      window.open(`${process.env.BASE_URL}passwordupdate`)
    },
    /**
     * ログアウト
     */
    async logout() {
      await this.$store.dispatch('logout')
      location.reload()
    },
  },
  created() {
    // この画面は別ウィンドウから開かれる前提です
    if (!window.opener) {
      this.$router.push('/')
    }

    this.companies = this.$store.state.companies
    this.$store.state.companies
    // this.loginForm.companyCode = this.companyCode =
    //   storage.getItem(LAST_COMPANY_CODE_KEY) || this.companies[0].code

    const authInfoSaved = {
      userId: getUserId(),
      companyCode: getCompanyCode(),
      loginId: getLoginId(),
      accessToken: getAccessToken(),
      refreshToken: getRefreshToken(),
    }

    if (
      authInfoSaved.userId &&
      authInfoSaved.companyCode &&
      authInfoSaved.loginId &&
      authInfoSaved.accessToken &&
      authInfoSaved.refreshToken
    ) {
      this.authInfo.userId = authInfoSaved.userId
      this.authInfo.companyCode = authInfoSaved.companyCode
      this.authInfo.loginId = authInfoSaved.loginId
    }
  },
}
</script>

<style scoped lang="scss">
header {
  background: var(--md-theme-default-primary, #448aff);
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100; // force top

  .app-title {
    cursor: pointer;
  }
}

.header-row {
  align-items: center;
  display: flex;
  height: 56px;
  margin-left: 24px;
  margin-right: 24px;
}

.container {
  height: 100vh;
  width: 100vw;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login-form {
  width: 300px;
}

.account-select-form {
  text-align: center;

  .main {
    margin-bottom: 32px;
  }
}

.actions {
  text-align: center;
}

.error-message {
  text-align: center;
  color: #e91e63;
}

.login-id {
  font-family: monospace;
  font-size: 24px;
  display: inline-block;
  padding: 8px;
  margin-left: 8px;
  margin-right: 8px;
}

.logo {
  margin-bottom: 50px;
}
</style>
